export { default as LoyaltyButtonWidget } from './loyalty-button-widget';
